import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Click} from '../../models/click';
import {AuthService} from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ClickService extends AbstractModelService<Click> {

  constructor(apiClient: ApiClientService, private authService: AuthService) {
    super(apiClient, '/click', Click);
  }

  getDownloadUrl(parameters: any = {}): string {
    parameters['token'] = this.authService.getBearer();

    return this.apiClient.getUrl(this.routePath + '/download', parameters);
  }
}
